import { Button, Flex } from '@chakra-ui/react';

export type FilterOption = {
  value: string;
  label: string;
};

type Props = {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
};

// DS PillGroup (design-system/components/navigation/Tabs.jsx): text-only pills,
// active = brand fill, inactive = surface + border-strong. The primary/secondary
// button variants already map to exactly those DS tokens.
export default function FilterChips({ options, value, onChange }: Props) {
  return (
    <Flex gap={2} wrap='wrap'>
      {options.map((opt) => (
        <Button
          key={opt.value}
          size='sm'
          variant={opt.value === value ? 'primary' : 'secondary'}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </Button>
      ))}
    </Flex>
  );
}
